export default "__VITE_ASSET__CAzu9SF1__"